<template>
  <div class="benefits-page">
    <header class="benefits-header">
      <button
        type="button"
        class="back-button"
        :aria-label="$t('videoBenefits.back')"
        @click="$router.back()"
      >
        <span aria-hidden="true" />
      </button>
      <h1>{{ $t("videoBenefits.title") }}</h1>
    </header>

    <section
      v-for="section in benefitSections"
      :key="section.key"
      class="benefit-section"
      :class="section.key"
    >
      <h2>{{ $t(section.titleKey) }}</h2>
      <div class="benefit-grid">
        <article
          v-for="product in section.products"
          :key="product.id"
          class="benefit-product"
          @click="$router.push('/buy/1');"
        >
          <div class="product-image-wrap">
            <img
              :src="product.image"
              alt=""
            >
          </div>
          <p>{{ $t("videoBenefits.benefit", { number: product.number }) }}</p>
          <button
            type="button"
            class="claim-button"
          >
            {{ $t("videoBenefits.getItNow") }}
          </button>
        </article>
      </div>

      <div class="giveaway-card">
        <strong>{{ $t(section.giveawayTitleKey) }}</strong>
        <span>{{ $t("videoBenefits.giveawayDescription") }}</span>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Choose",
  data() {
    return {
      benefitSections: [
        {
          key: "sex-toys",
          titleKey: "videoBenefits.sexToys",
          giveawayTitleKey: "videoBenefits.sexToysGiveaway",
          products: [
            { id: "sex-1", number: 1, image: require("../images/ban5/5dc26b3afc2ca639d42e6839c1453496.jpg") },
            { id: "sex-2", number: 2, image: require("../images/ban5/710553a6a23cde8cc022b06368e52fe4.jpg") },
            { id: "sex-3", number: 3, image: require("../images/ban5/74463f11f004e8989c546820eed6d1fa.jpg") },
            { id: "sex-4", number: 4, image: require("../images/ban5/92391da257d70f47427288f3a3861f55.jpg") },
            { id: "sex-5", number: 5, image: require("../images/ban5/e11e2d2944f805ae0505bbbd7b089126.jpg") },
            { id: "sex-6", number: 6, image: require("../images/ban5/d144d29c9ef395690251de771051f1a1.jpg") }
          ]
        },
        {
          key: "luxury-goods",
          titleKey: "videoBenefits.luxuryGoods",
          giveawayTitleKey: "videoBenefits.luxuryGoodsGiveaway",
          products: [
            { id: "luxury-1", number: 1, image: require("../images/ban5/af78e4eb927879507cb8cc58b5e52421.jpg") },
            { id: "luxury-2", number: 2, image: require("../images/ban5/104956a7a4c2261c8ce07812e415213a.jpg") },
            { id: "luxury-3", number: 3, image: require("../images/ban5/92a872f0014c3b7e2cdb34b0dc294c58.jpg") },
            { id: "luxury-4", number: 4, image: require("../images/ban5/31474c1e375ddba642c949b3018b1f91.jpg") },
            { id: "luxury-5", number: 5, image: require("../images/ban5/a09ba9b97bdd9612a237ab4bcab51a85.jpg") },
            { id: "luxury-6", number: 6, image: require("../images/ban5/813e663c8d5b6ad0f8f94eeb33ae0457.jpg") }
          ]
        }
      ]
    };
  },
  created() {
    this.$parent.footer("item", true);
  },
  mounted() {
    if (localStorage.getItem("token") === null) {
      this.$router.push("/login");
    }
  }
};
</script>

<style lang="less" scoped>
.benefits-page {
  min-height: 100vh;
  padding: 12px 20px 76px;
  box-sizing: border-box;
  background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
}

.benefits-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  margin-bottom: 18px;
}

.benefits-header h1,
.benefit-section h2,
.benefit-product p,
.giveaway-card strong,
.giveaway-card span {
  margin: 0;
}

.benefits-header h1 {
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.back-button {
  position: absolute;
  top: 50%;
  left: -4px;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  transform: translateY(-50%);
}

.back-button span {
  position: absolute;
  top: 7px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-bottom: 1px solid #121212;
  border-left: 1px solid #121212;
  transform: rotate(45deg);
}

.benefit-section + .benefit-section {
  margin-top: 18px;
}

.benefit-section h2 {
  height: 30px;
  padding: 0 10px;
  border-radius: 5px;
  background: linear-gradient(100deg, #d851bd 0%, #6e3dc4 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
}

.benefit-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 10px;
  margin-top: 16px;
}

.benefit-product {
  min-width: 0;
}

.product-image-wrap {
  width: 100%;
  padding-top: 100%;
  overflow: hidden;
  border-radius: 5px;
  background: #fff;
}

.product-image-wrap img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-image-wrap {
  position: relative;
}

.product-image-wrap img {
  top: 0;
  left: 0;
}

.benefit-product p {
  padding: 4px 0 7px;
  overflow: hidden;
  color: #000;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.claim-button {
  display: block;
  width: 100%;
  height: 24px;
  padding: 0 4px;
  overflow: hidden;
  border: 0;
  border-radius: 13px;
  background: linear-gradient(100deg, #dc4ab7 0%, #6d3bc4 100%);
  color: #fff;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.giveaway-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 66px;
  margin-top: 18px;
  padding: 7px 10px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fb4d95;
  color: #fff;
  text-align: center;
}

.giveaway-card strong {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.giveaway-card span {
  margin-top: 3px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}
</style>
